import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuButton } from 'src/components/shared/buttons/MenuButton';
import { CharacterImage } from 'src/components/shared/CharacterImage';
import { Star } from 'src/components/shared/Star';
import { replaceAllSpaces } from 'src/lib/utils';

interface ResortUserInfoProps {
  name: string;
  image: string;
  isMyself: boolean;
  resortPlannerGrade: string;
  resortPlannerId: string;
  isReported?: boolean;
  isFollowing?: boolean;
  onMenuClick?: () => void;
}

export const ResortUserInfo: React.FC<ResortUserInfoProps> = ({
  name,
  image,
  isMyself,
  resortPlannerGrade,
  resortPlannerId,
  isReported,
  isFollowing,
  onMenuClick
}) => {
  const { t } = useTranslation(['resort', 'best_friends', 'translation']);
  const innerColor = isFollowing ? '#ffc700' : '#F0F5D7';
  const strokeColor = isFollowing ? '#ad8700' : '#938666';
  return (
    <div
      className={css`
        .profile {
          display: flex;
          color: #4d3906;
          margin-bottom: 8px;
        }
        .player-image {
          position: relative;
          flex: 0 0 auto;
          width: 48px;
          height: 48px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .star {
          position: absolute;
          top: -4px;
          right: -4px;
        }
        .names {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .grade {
          font-size: 12px;
          margin-bottom: 2px;
        }
        .name {
          font-size: 20px;
        }
        .menu {
          flex: 0 0 auto;
        }
        .resort-planner-id {
          font-size: 12px;
          color: #938666;
        }
      `}
    >
      <div className="profile">
        <div className="player-image">
          <CharacterImage
            src={image}
            isReported={isReported}
            isPlayer={true}
            imageAriaLabel={t('best_friends:aria_player_image')}
          />
          {isMyself ? null : (
            <div className="star">
              <Star size={20} innerColor={innerColor} strokeColor={strokeColor} />
            </div>
          )}
        </div>
        <div className="names">
          <span className="grade">{resortPlannerGrade}</span>
          <span className="name">
            {isReported ? t('translation:reported_player') : replaceAllSpaces(name)}
          </span>
        </div>
        {onMenuClick && (
          <div className="menu">
            <MenuButton
              onClick={onMenuClick}
              activeColor="#dfd9c9"
              ariaLabel={t('aria_button_report_menu')}
            />
          </div>
        )}
      </div>
      <p className="resort-planner-id">{t('resort_planner_id_label', { id: resortPlannerId })}</p>
    </div>
  );
};
